import { useState, useCallback, useMemo } from 'react';
import { ChatContext } from './ChatContext';
import { useChildComponent } from '@gogame/hooks-ts';

export const ChatProvider = ({ children, id, onChangeId }) => {
  const [chatId, setChatId] = useState(id);
  const [childComponent, openChildComponent] = useChildComponent();

  const handleSetId = useCallback(
    (newId) => {
      setChatId(newId);
      onChangeId?.(newId);
    },
    [onChangeId]
  );

  const contextValue = useMemo(
    () => ({
      chatId,
      setChatId: handleSetId,
      openChildComponent,
    }),
    [chatId, handleSetId, openChildComponent]
  );

  return (
    <ChatContext.Provider value={contextValue}>
      {children}
      {childComponent}
    </ChatContext.Provider>
  );
};
